var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
/**
 * Compact segmented control for picking one mode from a short list
 * (typically 2-4 options). Matches the study-list design tokens of the
 * strategy study list.
 *
 * Emits `mode-change` with `detail: { value: string }`.
 */
let ModeInput = class ModeInput extends LitElement {
    constructor() {
        super(...arguments);
        this.options = [];
        this.size = 'medium';
        this.disabled = false;
    }
    handleClick(value) {
        if (this.disabled || this.value === value)
            return;
        this.value = value;
        this.dispatchEvent(new CustomEvent('mode-change', {
            detail: { value },
            bubbles: true,
            composed: true,
        }));
    }
    render() {
        return html `
      <div class="track" role="tablist">
        ${this.options.map((opt) => html `
            <button
              type="button"
              role="tab"
              class=${`opt ${this.value === opt.value ? 'selected' : ''}`}
              aria-selected=${this.value === opt.value ? 'true' : 'false'}
              @click=${() => this.handleClick(opt.value)}
            >
              ${opt.icon ? html `<span class="icon">${opt.icon}</span>` : null}
              <span>${opt.label}</span>
            </button>
          `)}
      </div>
    `;
    }
};
ModeInput.styles = css `
    :host {
      display: inline-block;
      font-family: inherit;
      color: #333;
    }

    .track {
      display: inline-flex;
      align-items: center;
      gap: 2px;
      padding: 3px;
      background: #f0f4f8;
      border: 1px solid #e2e8ef;
      border-radius: 8px;
      box-sizing: border-box;
    }

    :host([disabled]) .track {
      opacity: 0.55;
      pointer-events: none;
    }

    button.opt {
      appearance: none;
      -webkit-appearance: none;
      border: none;
      background: transparent;
      color: #555;
      font-family: inherit;
      font-size: 12px;
      font-weight: 500;
      padding: 5px 12px;
      border-radius: 6px;
      cursor: pointer;
      display: inline-flex;
      align-items: center;
      gap: 6px;
      line-height: 1;
      transition:
        background 0.15s,
        color 0.15s,
        box-shadow 0.15s;
      white-space: nowrap;
    }

    /* medium (default) */
    :host([size='medium']) button.opt {
      font-size: 12px;
      padding: 5px 12px;
    }

    /* small */
    :host([size='small']) button.opt {
      font-size: 11px;
      padding: 4px 10px;
    }

    button.opt:hover:not(.selected) {
      background: #e6eef5;
      color: #0062c4;
    }

    button.opt.selected {
      background: #fff;
      color: #0078d4;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
    }

    button.opt .icon {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 14px;
      height: 14px;
    }
  `;
__decorate([
    property({ type: Array })
], ModeInput.prototype, "options", void 0);
__decorate([
    property({ type: String })
], ModeInput.prototype, "value", void 0);
__decorate([
    property({ type: String })
], ModeInput.prototype, "size", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], ModeInput.prototype, "disabled", void 0);
ModeInput = __decorate([
    customElement('mode-input')
], ModeInput);
export { ModeInput };
//# sourceMappingURL=ModeInput.js.map